import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { OrderDetailManagementTable } from '../../OrderDetailManagementTable';
import { formatMultibancoReference, formatPhoneNumber } from '@utils/format';
import { TableProps } from '@components/atoms/Table';

export interface PaymentsTableProps {
    name: string;
    method: string;
    multibancoEntity?: string;
    multibancoReference?: string;
    phoneNumber?: string;
}

export const PaymentsTable: FC<PaymentsTableProps> = ({ name, method, multibancoEntity, multibancoReference, phoneNumber }) => {
    const { t } = useTranslation();

    const translations = {
        type: t('payments-table-component.type'),
        multibancoEntity: t('payments-table-component.header.multibanco-entity'),
        multibancoReference: t('payments-table-component.header.multibanco-reference'),
        phoneNumber: t('payments-table-component.header.phone-number'),
    };

    const getHeader = useCallback(() => {
        const header: TableProps['headerCols'] = [{ text: translations.type }];

        if (method === 'mbway') {
            header.push({ classes: 'text-start text-md-center', text: translations.phoneNumber });
        } else if (method === 'multibanco') {
            header.push({ classes: 'text-start text-md-center', text: translations.multibancoEntity });
            header.push({ classes: 'text-start text-md-center', text: translations.multibancoReference });
        }

        return header;
    }, [translations.type, translations.phoneNumber, translations.multibancoEntity, translations.multibancoReference, method]);

    const getContent = useCallback(() => {
        const content: {
            classes?: string;
            content: string | JSX.Element;
            acceptsHTML?: boolean;
        }[] = [{ content: name }];

        if (method === 'mbway') {
            content.push({ classes: 'text-start text-md-center', content: formatPhoneNumber(phoneNumber || '') });
        } else if (method === 'multibanco') {
            content.push({ classes: 'text-start text-md-center', content: multibancoEntity || '' });
            content.push({ classes: 'text-start text-md-center', content: formatMultibancoReference(multibancoReference || '') });
        }

        return content;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [method]);

    return (
        <OrderDetailManagementTable header={getHeader()} content={[{ cells: getContent(), options: [] }]} withActions={false} />
    );
};
